"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __importDefault(require("../../config"));
/**
 * @function selectGradeTheme
 * @param {number} grade Selected grade to choose theme
 * @description Returns the associated theme based on grade level
 * @returns {ThemesEnum} Selected theme
 */
var selectGradeTheme = function (grade) {
    if (grade === void 0) { grade = -1; }
    return config_1.default.defaults.themePerGradeMap[grade] || config_1.default.defaults.theme;
};
exports.default = selectGradeTheme;
